import { GuestRecipeBoxData } from '../../../recipes/providers/guest-recipe-box-data';
import { Component } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { LoginPage } from '../login/login';
import { AppSettings } from '../../../../config/app-settings';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AccountCommon } from './account.common';

@Component({
	selector: 'page-account-full',
  	templateUrl: 'account.full.html'
})

export class AccountPageFull extends PageBaseFull{
	
	public currentUser: any;
	public useremail: string;
	public nameInitials: string;
	public modal: any;

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: AccountCommon,
		public app: App,
		public guestRecipeBoxData: GuestRecipeBoxData
	) {
		super(settings, events, nav, userData);
		console.log("Loading Account Full");
	}

	ionViewDidEnter() {
		this.app.setTitle('My Account');
	}

	ngAfterViewInit() {
		let self = this;

		// self.currentUser = {
		// 	email : "thang@mcmtechnologies.com", 
		// 	displayName : "Thang Do",
		// 	firstName : "Thang",
		// 	lastName : "Do",
		// 	photoURL : "http://themehats.com/themes/jango/assets/base/img/content/team/team10.jpg",
		// 	primaryPhone : "8321111111",
		// 	state : "TX",
		// 	zipCode : "77014",
		// 	city : "Houston",
		// 	address : "13700 Veterans Memorial Dr"
		// }

		self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
			if(isLoggedIn){
				self.common.loadUserData(this.nav);
			}
			else{
				self.nav.setRoot(LoginPage);
			}
		});
	}

	signOut(){
		this.common.signOut(this.nav);
		this.guestRecipeBoxData.cleanData();
	}


}



// WEBPACK FOOTER //
// ./src/modules/account/pages/account/account.full.ts